import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=7f27777a&scoped=true&"
import script from "./main-header.ts?vue&type=script&lang=ts&"
export * from "./main-header.ts?vue&type=script&lang=ts&"
import style0 from "./main-header.scss?vue&type=style&index=0&id=7f27777a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27777a",
  null
  
)

export default component.exports